import { useContext } from 'react';
import { ConflictsContext } from '../context';

export function useConflictsContext(): ConflictsContext {
  const context = useContext(ConflictsContext);
  if (!context) {
    throw new Error('Unable to find ConflictsContext');
  }

  return context;
}
